// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"59":"9232eda6791b118ebe05","925":"ae56fa8c03742e356b48"}[chunkId] + ".bundle.js";
};